(() => {
  const configElement = document.getElementById('lc-opening-hours-exception-data');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  let calendar;
  let hoursObserver;
  const weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const regularHours = {
    Mon: '10:00–17:00', Tue: '10:00–17:00', Wed: '10:00–17:00',
    Thu: '10:00–17:00', Fri: '10:00–17:00', Sat: '12:00–15:00'
  };

  function updateHours() {
    const parts = Object.fromEntries(calendar.formatToParts(new Date()).map(part => [part.type, part.value]));
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const closed = today === config.date;
    document.querySelectorAll('[data-lc-hours-notice]').forEach(notice => {
      notice.hidden = today > config.date;
    });
    document.querySelectorAll('[data-lc-hours-regular]').forEach(time => {
      time.textContent = closed ? time.dataset.lcHoursClosed : time.dataset.lcHoursRegular;
    });
    document.querySelectorAll('#lc-ft [data-days]').forEach(row => {
      const isToday = row.dataset.days.split(',').includes(String(weekdays[parts.weekday]));
      row.classList.toggle('is-today', isToday);
      const label = row.querySelector('.lc-ft__today');
      if (label) label.hidden = !isToday;
    });
    document.querySelectorAll('[data-lc-ch-today]').forEach(status => {
      const hours = closed ? null : regularHours[parts.weekday];
      status.textContent = `${status.dataset.label}: ${hours || status.dataset.closed}`;
      status.classList.toggle('is-closed', !hours);
      status.hidden = false;
    });
  }

  function startHours() {
    if (!calendar) {
      calendar = new Intl.DateTimeFormat('en-US', {
        timeZone: config.time_zone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short'
      });
      hoursObserver?.disconnect();
      setInterval(updateHours, 60000);
    }
    updateHours();
  }

  document.addEventListener('shopify:section:load', startHours);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && calendar) updateHours();
  });

  // Keep contact/editor and every future or recent closure eager. Static hours
  // stay server-rendered; the 48h guard safely covers the Amsterdam date boundary.
  const closureGuardEnd = Date.parse(`${config.date}T00:00:00Z`) + 48 * 60 * 60 * 1000;
  if (document.querySelector('[data-lc-ch-today]') || window.Shopify?.designMode ||
      typeof IntersectionObserver !== 'function' || !Number.isFinite(closureGuardEnd) ||
      Date.now() <= closureGuardEnd) {
    startHours();
  } else {
    hoursObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) startHours();
    }, { rootMargin: '300px 0px' });
    document.querySelectorAll('[data-lc-hours-regular], [data-lc-hours-notice], #lc-ft [data-days]')
      .forEach(target => hoursObserver.observe(target));
  }
})();
